import React, { useState } from "react";
import { TextField, Box, Button, FormControl } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import FormHelperText from "@mui/material/FormHelperText";
import { enqueueSnackbar } from "notistack";
import LoadingButton from "@mui/lab/LoadingButton";
import { resendCodigo, validarCodigo } from "./ValidationService";
import { getDecryptedDataFromSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

const validationSchema = Yup.object({
  code: Yup.string()
    .matches(/^\d{6}$/, "El formato del código es incorrecto")
    .required("Este campo es obligatorio"),
});

export const ValidationForm = ({ onClose, userEmail }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      code: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await validarCodigo(userEmail, values.code);
        if (response.statusResult == 200) {
          navigate("/dashboard");
          //localStorage.setItem("isValidated", "true");
        } else {
          enqueueSnackbar(response.errors[0], { variant: "error" });
        }
      } catch (error) {
        // (error, "activeError");
        enqueueSnackbar(error, { variant: "error" });
      } finally {
        setLoading(false);
      }
    },
  });

  const handleResendCode = async () => {
    setLoading(true);
    try {
      const response = await resendCodigo(userEmail);
      if (response.statusResult == 200) {
        enqueueSnackbar("El nuevo código ha sido reenviado", {
          variant: "success",
        });
      }
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box margin={2}>
      <form onSubmit={formik.handleSubmit} id="my-form">
        <Box sx={{ position: "relative" }}>
          <FormControl fullWidth variant="outlined">
            <FormHelperText sx={{ minHeight: "24px", mb: 2, ml: 0 }}>
              El código será enviado al mail registrado de la cuenta
            </FormHelperText>
            <TextField
              fullWidth
              label="Código de verificación"
              name="code"
              variant="outlined"
              value={formik.values.code}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={Boolean(formik.errors.code)}
              InputProps={{
                style: { minHeight: "56px" },
              }}
              FormHelperTextProps={{
                style: { minHeight: "24px" },
              }}
            /> 
          </FormControl>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ flexGrow: 1 }}>
            <FormHelperText sx={{ minHeight: "24px", color: "red" }}>
              {formik.errors.code}
            </FormHelperText>
            </Box>
            <Button
              variant="text"
              color="primary"
              onClick={handleResendCode}
              sx={{
                textTransform: "none",
                "&:hover": { backgroundColor: "transparent" },
              }}
            >
              Reenviar código
            </Button>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
          <LoadingButton
            loading={loading}
            color="primary"
            fullWidth
            size="large"
            variant="contained"
            type="submit"
            disabled={Boolean(formik.errors.code)}
          >
            Validar
          </LoadingButton>
          <LoadingButton
            color="primary"
            fullWidth
            size="large"
            variant="outlined"
            type="button"
            onClick={onClose}
          >
            Cerrar
          </LoadingButton>
        </Box>
      </form>
    </Box>
  );
};
